import { forwardRef } from 'react'
import { IconProps } from 'almanac-ui/icons/Types'

export const AlignItemsCenter = forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', size = 16 }, forwardedRef) => {
    return (
      <svg
        width={size}
        height={size}
        style={{ width: size, height: size }}
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={forwardedRef}
      >
        <path
          fill={color}
          fillRule="evenodd"
          d="M4 6.5V3h8v3.5H4Zm3.5-5V2H4a1 1 0 0 0-1 1v3.5a1 1 0 0 0 1 1h3.5v1H6a1 1 0 0 0-1 1V13a1 1 0 0 0 1 1h1.5v.5a.5.5 0 0 0 1 0V14H10a1 1 0 0 0 1-1V9.5a1 1 0 0 0-1-1H8.5v-1H12a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1H8.5v-.5a.5.5 0 0 0-1 0ZM8 13H6V9.5h4V13H8Z"
          clipRule="evenodd"
        />
      </svg>
    )
  },
)

export default AlignItemsCenter
